export const IS_PROD_ENV =
  import.meta.env.VITE_VERCEL_ENV === 'production' ||
  import.meta.env.VITE_VERCEL_GIT_COMMIT_REF === 'ias-pre-prod';
export const IS_STAGING_ENV =
  import.meta.env.VITE_VERCEL_GIT_COMMIT_REF === 'staging';
export const IS_DEVELOPMENT_ENV =
  import.meta.env.VITE_VERCEL_ENV === 'development' || import.meta.env.DEV;

const getXPlumTokenCookieNameByEnv = () => {
  return IS_PROD_ENV ? 'x-plum-prod-token' : 'x-plum-staging-token';
};

// add all env varialbes here
const AppConfig = {
  APP_NAME: 'in-app-support-center',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  CORE_BACKEND_BASE_URL: import.meta.env.VITE_CORE_BACKEND_BASE_URL,
  EMPLOYEE_EXPERIENCE_BASE_URL: import.meta.env
    .VITE_EMPLOYEE_EXPERIENCE_BASE_URL,
  CLAIMS_BASE_URL: import.meta.env.VITE_CLAIMS_BASE_URL,
  TELEHEALTH_BASE_URL: import.meta.env.VITE_TELEHEALTH_BASE_URL,
  TOKEN_ADDED_VIA_EXTERNAL_APPLICATION_EVENT:
    'TOKEN_ADDED_VIA_EXTERNAL_APPLICATION',
  LOCAL_STORAGE_JWT_TOKEN_KEY: 'x-plum-token',
  PLUM_APP_HOST_URL: import.meta.env.VITE_PLUM_APP_HOST_URL,
  SSO_HOST_URL: import.meta.env.VITE_SSO_HOST_URL,
  POLICY_GPT_BOT_ID: '2477f8c7-30e0-48b7-8abb-4e8691185095',
  CLAIMS_BOT_ID: 'b1c0ef24-6bba-486e-b6ca-0fdb46062d26',
  TRANSACTIONAL_BOT_ID: '8622806b-e03b-488a-8772-903f0ea18860',
  NEW_RELIC_LOG_ENDPOINT: import.meta.env.VITE_NEW_RELIC_LOG_ENDPOINT,
  BOTPRESS_SCRIPT: 'https://cdn.botpress.dev/webchat/v0/inject.js',
  CHAT_FRAMEWORK_BASE_URL: import.meta.env.VITE_CHAT_FRAMEWORK_BASE_URL,
  JWT_TOKEN_COOKIE_NAME: getXPlumTokenCookieNameByEnv(),
  CLEVERTAP_ACCOUNT_ID: import.meta.env.VITE_CLEVERTAP_ACCOUNT_ID,
};

export default AppConfig;
